<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-skeleton-loader v-if="$store.state.reminders.retrieveLoader" transition="fade-transition" type="toolbar" />
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <v-row align="center" justify="start" no-gutters>
              <router-link class="subtitle-1 routerLink font-weight-medium" :to="{name: 'Receivables'}">Cuentas por cobrar</router-link>
              <v-icon class="mx-1 pt-1" color="secondary">mdi-chevron-right</v-icon>
              <span>Recordatorios enviados</span>
            </v-row>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-query-builder :query-map="filters" model="message" class="mr-1" />
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0">
          <v-row no-gutters>
            <v-col cols="12">
              <v-skeleton-loader v-if="$store.state.reminders.retrieveLoader" transition="fade-transition" type="table" />
              <template v-else>
                <template v-if="messagesList.length">
                  <v-data-table :headers="headers" :items="messagesList" :items-per-page="pagination" mobile-breakpoint hide-default-header disable-sort hide-default-footer>
                    <!-- header -->
                    <template v-slot:[`header`]="{ props: { headers } }">
                      <VTableHeaders :headers="headers" @sort="setSort" />
                    </template>
                    <!-- end header -->
                    <template v-slot:[`item.invoice`]="{item}">
                      <span class="d-block text--secondary font-weight-medium text-truncate">{{item.invoice.document | invoiceTypeName}} Nº {{item.invoice.number}}</span>
                      <span class="d-block text-truncate">{{item.invoice.date | date}}</span>
                    </template>
                    <template v-slot:[`item.customer`]="{item}">
                      <span class="d-block text-truncate">{{item.invoice.customer}}</span>
                    </template>
                    <template v-slot:[`item.message`]="{item}">
                      <v-menu open-on-hover right offset-x :nudge-width="100" max-width="320" transition="slide-x-transition">
                        <template v-slot:activator="{on}">
                          <span class="d-block text-truncate" v-on="on">{{item.subject}}</span>
                          <span class="d-block text-truncate" v-on="on">{{item.message}}</span>
                        </template>
                        <v-card>
                          <v-card-text class="text--primary"><span class="text--secondary">Asunto:</span> {{item.subject}}</v-card-text>
                          <v-divider />
                          <v-card-text class="text--primary">{{item.message}}</v-card-text>
                        </v-card>
                      </v-menu>
                    </template>
                    <template v-slot:[`item.recipient`]="{item}">
                      {{item.recipient[0]}}
                      <v-tooltip v-if="item.recipient.length > 1" right min-width="200px" transition="scale-transition">
                        <template v-slot:activator="{on}">
                          <v-chip class="ml-1" v-on="on" color="secondary" small>+{{item.recipient.length - 1}}</v-chip>
                        </template>
                        <v-list>
                          <v-list-item v-for="r in item.recipient" :key="r">
                            <v-list-item-avatar color="primary" size="28">
                              <span class="body-2 white--text">{{r.substring(0, 2).toUpperCase()}}</span>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title>{{r}}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-tooltip>
                    </template>
                    <template v-slot:[`item.created`]="{item}">
                      <span class="text-right">{{item.created | date}}</span>
                    </template>
                  </v-data-table>
                  <v-divider />
                  <v-row class="mx-0" align="center">
                    <v-col cols="6">
                      <span class="body-2 text--secondary">{{count}} registros</span>
                    </v-col>
                    <v-col cols="6" class="text-right">
                      <v-pagination v-model="page" :length="totalPages" total-visible="6"></v-pagination>
                    </v-col>
                  </v-row>
                </template>
                <v-row v-else>
                  <v-col class="pb-6 pt-4 text-center">
                    <v-icon class="d-block" color="secondary" size="70">mdi-badge-account-horizontal</v-icon>
                    <span class="d-block subtitle-1 my-2">No existen recordatorios</span>
                  </v-col>
                </v-row>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'

import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import VTableHeaders from '@/components/VTable/VTableHeaders'

import ListViewMixin from '@/mixins/ListViewMixin'

export default {
  components: {
    VQueryBuilder,
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    filters: [
      {
        type: 'text',
        id: 'created',
        label: 'Fecha de envío',
        operators: ['es menor a', 'es mayor a']
      },
      {
        type: 'text',
        id: 'recipient__icontains',
        label: 'Destinatario',
        operators: ['contiene']
      },
      {
        type: 'text',
        id: 'invoice__customer__name',
        label: 'Cliente',
        operators: ['contiene']
      },
      {
        type: 'text',
        id: 'invoice__date',
        label: 'Fecha de la factura',
        operators: ['es igual', 'es menor a', 'es mayor a']
      },
      {
        type: 'text',
        id: 'invoice__due_date',
        label: 'Fecha de vencimiento de la factura',
        operators: ['es igual', 'es menor a', 'es mayor a']
      },
      {
        type: 'numeric',
        id: 'invoice__number',
        label: 'Número de la factura',
        operators: ['es igual', 'es menor a', 'es mayor a']
      },
      {
        type: 'select',
        id: 'invoice__document',
        label: 'Tipo de factura',
        choices: []
      }
    ],
    headers: [
      { text: 'Factura', value: 'invoice', class: 'font-weight-bold', sortable: false },
      { text: 'Cliente', value: 'customer', class: 'font-weight-bold', sortable: false },
      { text: 'Mensaje', value: 'message', sortable: false },
      { text: 'Destinatarios', value: 'recipient', sortable: false },
      { text: 'Enviado', value: 'created', align: 'end', sortable: true }
    ]
  }),
  computed: mapState({
    count: state => state.reminders.messagesCount,
    messagesList: state => state.reminders.messagesList
  }),
  methods: {
    getList () {
      this.$store.dispatch('reminders/LIST', {
        resource: 'reminders/messages',
        query: {
          expand: 'invoice',
          invoice__isnull: 'False',
          ...this.$route.query
        }
      })
    }
  }
}
</script>
